<template>
  <div class="cube-onlyoffice">
    <div :id="id"></div>
    <div v-if="showLogo" class="cube-onlyoffice-logo">OFFICE</div>
  </div>
</template>

<script>
import loadScript from '../utils/loadScript'

import { createParams, documentServerUrl } from '../utils/params.js'
import '../../../../lib/styles/components/OnlyOffice.scss'
export default {
  name: 'OnlyOffice',
  props: {
    id: {
      type: String,
      required: true,
      default: 'only-office'
    },
    documentServerUrl: {
      type: String,
      required: true,
      default: documentServerUrl
    },
    config: {
      type: Object,
      required: true,
      default: () => { return {} }
    },
    callbackUrl: {
      type: String,
      default: ''
    },
    loadToken: {
      type: Function
    },
    document_fileType: String,
    document_title: String,
    documentType: String,
    editorConfig_lang: String,
    height: String,
    type: String,
    width: String,
    onLoadComponentError: Function,
    events_onAppReady: Function,
    events_onDocumentStateChange: Function,
    events_onMetaChange: Function,
    events_onDocumentReady: Function,
    events_onInfo: Function,
    events_onWarning: Function,
    events_onError: Function,
    events_onRequestSharingSettings: Function,
    events_onRequestRename: Function,
    events_onMakeActionLink: Function,
    events_onRequestInsertImage: Function,
    events_onRequestSaveAs: Function,
    events_onRequestMailMergeRecipients: Function,
    events_onRequestCompareFile: Function,
    events_onRequestEditRights: Function,
    events_onRequestHistory: Function,
    events_onRequestHistoryClose: Function,
    events_onRequestHistoryData: Function,
    events_onRequestRestore: Function
  },
  data() {
    return {
      tokenUsage: {
        url: 'system/contract/office/create/token',
        value: null
      },
      showLogo: false
    }
  },
  watch: {
    config: {
      handler: function(newVal, oldVal) {
        this.onChangeProps()
      },
      deep: true
    },
    document_fileType: function(newVal, oldVal) { this.onChangeProps() },
    document_title: function(newVal, oldVal) { this.onChangeProps() },
    documentType: function(newVal, oldVal) { this.onChangeProps() },
    editorConfig_lang: function(newVal, oldVal) { this.onChangeProps() },
    height: function(newVal, oldVal) { this.onChangeProps() },
    type: function(newVal, oldVal) { this.onChangeProps() },
    width: function(newVal, oldVal) { this.onChangeProps() }
  },
  mounted() {
    if (!this.config) return
    const { key, url, title } = this.config.document
    const {
      callbackUrl
    } = this
    this.loadToken(Object.assign(this.config, createParams(key, url, title, callbackUrl))).then(res => {
      this.tokenUsage.value = res.data
      const docApiUrl = this.documentServerUrl
      loadScript(docApiUrl, 'onlyoffice-api-script')
        .then(() => this.onLoad())
        .catch(() => { this.onError(-2) })
    })
  },
  unmounted() {
    const id = this.id || ''
    if (window?.DocEditor?.instances[id]) {
      window.DocEditor.instances[id].destroyEditor()
      window.DocEditor.instances[id] = undefined
    }
  },
  methods: {
    onLoad() {
      try {
        const id = this.id || ''
        if (!window.DocsAPI) this.onError(-3)
        if (window?.DocEditor?.instances[id]) {
          console.log('Skip loading. Instance already exists', id)
          return
        }

        if (!window?.DocEditor?.instances) {
          window.DocEditor = { instances: {}}
        }

        const initConfig = Object.assign({
          token: this.tokenUsage.value,
          document: {
            fileType: this.document_fileType,
            title: this.document_title
          },
          documentType: this.documentType,
          editorConfig: {
            lang: 'zh', // this.editorConfig_lang,
            callbackUrl: this.callbackUrl,
            // 'coEditing': {
            //   'mode': 'strict',
            //   'change': false
            // },
            'mode': 'view'
          },
          events: {
            onAppReady: this.onAppReady,
            onDocumentStateChange: this.events_onDocumentStateChange,
            onMetaChange: this.events_onMetaChange,
            onDocumentReady: this.events_onDocumentReady,
            onInfo: this.events_onInfo,
            onWarning: this.events_onWarning,
            onError: this.events_onError,
            onRequestSharingSettings: this.events_onRequestSharingSettings,
            onRequestRename: this.events_onRequestRename,
            onMakeActionLink: this.events_onMakeActionLink,
            onRequestInsertImage: this.events_onRequestInsertImage,
            onRequestSaveAs: this.events_onRequestSaveAs,
            onRequestMailMergeRecipients: this.events_onRequestMailMergeRecipients,
            onRequestCompareFile: this.events_onRequestCompareFile,
            onRequestEditRights: this.events_onRequestEditRights,
            onRequestHistory: this.events_onRequestHistory,
            onRequestHistoryClose: this.events_onRequestHistoryClose,
            onRequestHistoryData: this.events_onRequestHistoryData,
            onRequestRestore: this.events_onRequestRestore
          },
          height: this.height,
          type: this.type,
          width: this.width
        }, this.config || {})
        const editor = window.DocsAPI.DocEditor(id, initConfig)
        window.DocEditor.instances[id] = editor

        this.$nextTick(() => { this.showLogo = true })
        this.$emit('onload', editor)
      } catch (err) {
        console.error(err)
        this.onError(-1)
      }
    },
    onError(errorCode) {
      let message

      switch (errorCode) {
        case -2:
          message = 'Error load DocsAPI from ' + this.documentServerUrl
          break
        case -3:
          message = 'DocsAPI is not defined'
          break
        default:
          message = 'Unknown error loading component'
          errorCode = -1
      }

      if (typeof this.onLoadComponentError === 'undefined') {
        console.error(message)
      } else {
        this.onLoadComponentError(errorCode, message)
      }
    },
    onAppReady() {
      const id = this.id || ''
      this.events_onAppReady(window.DocEditor.instances[id])
    },
    onChangeProps() {
      const id = this.id || ''

      if (window?.DocEditor?.instances[id]) {
        window.DocEditor.instances[id].destroyEditor()
        window.DocEditor.instances[id] = undefined

        console.log('Important props have been changed. Load new Editor.')
        this.onLoad()
      }
    }
  }
}
</script>
